// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3FFjj","list":"styles_list__1E_Up"};